import { BoxEntityType, BoxItem } from "../service/box-file-structure.service";

export type BoxFolderType = 'ORGANIZATION' | 'COMPANY' | 'FUND';

export class BoxAccessPropsDTO {
  accessToken: string;
  folderID: string;
}

export interface BoxEmailDTO {
  email: string;
  captchaV2Token: string;
  captchaV3Token: string;
}

export interface BoxEmailDTORs {
  secToNextAttempt: number;
}

export interface BoxItemInfoWrapper {
  items: BoxItem[];
  isFromDataAdminRoom: boolean;
}

export interface BoxNotificationWrapper {
  orgUUID: string;
  companyFolderId: string;
}

export interface BoxMoveItemsWrapper {
  selectedItems: BoxItem[];
  rootOrDestinationFolder: BoxItem;
}

export interface MoveBoxWrapper {
  selectedItems: BoxItem[];
  rootFolderId: string;
}

export interface BoxNodeInfo {
  title: string;
  id: string;
  type: BoxEntityType;
  disabled: boolean;
}

export interface DetailedBoxNodeInfo extends BoxNodeInfo {
  isOpened?: boolean;
  data?: DetailedBoxNodeInfo[];
}

export class BoxFileWithMetadataDTO {
  id: string;
  fileName: string;
  metadata: string;
}

export class BoxFileWithSaveSlotDto {
  id: string;
  type: BoxEntityType;
  saveSlot: string;
}

export class BoxTreeStateWrapper {
  moveModal: boolean;
}
